import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import CloseIcon from "@mui/icons-material/Close";

const EditarOrganizacionModal = ({ open, onClose, onSubmit, organizacion, clientes, isLoading }) => {
  const [clienteId, setClienteId] = useState("");
  const [dominio, setDominio] = useState("");
  const [proveedorSSO, setProveedorSSO] = useState("");
  const [habilitada, setHabilitada] = useState(true);

  useEffect(() => {
    if (open && organizacion) {
      setClienteId(organizacion.clienteId ?? "");
      setDominio(organizacion.dominio ?? "");
      setProveedorSSO(organizacion.proveedorSSO ?? "");
      setHabilitada(organizacion.habilitada ?? true);
    }
  }, [open, organizacion]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      id: organizacion.id,
      clienteId: Number(clienteId),
      dominio,
      proveedorSSO,
      habilitada,
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8, color: (t) => t.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" sx={{ mb: 2 }}>Editar organización SSO</Typography>
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth margin="normal" required>
            <InputLabel>Cliente</InputLabel>
            <Select
              value={clienteId}
              label="Cliente"
              onChange={(e) => setClienteId(e.target.value)}
            >
              {clientes?.map((c) => (
                <MenuItem key={c.id} value={c.id}>{c.nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Dominio corporativo"
            placeholder="empresa.com"
            value={dominio}
            onChange={(e) => setDominio(e.target.value)}
            margin="normal"
            required
            helperText="Solo el dominio, sin @ (ej: empresa.com)"
          />

          <FormControl fullWidth margin="normal" required>
            <InputLabel>Proveedor SSO</InputLabel>
            <Select
              value={proveedorSSO}
              label="Proveedor SSO"
              onChange={(e) => setProveedorSSO(e.target.value)}
            >
              <MenuItem value="Microsoft">Microsoft</MenuItem>
              <MenuItem value="Google">Google</MenuItem>
            </Select>
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox checked={habilitada} onChange={(e) => setHabilitada(e.target.checked)} />
            }
            label="Organización habilitada"
            sx={{ mt: 1 }}
          />

          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button type="submit" variant="contained" color="primary" disabled={isLoading}>
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default EditarOrganizacionModal;